import { ReactComponent as SvgLock } from '@img/icons/padlock-unbranded.svg';
import { ReactComponent as SvgSearch } from '@img/icons/search.svg';
import React from 'react';
import S from './Textbox.styles';
const Textbox = React.forwardRef(({ className, hasError = false, readOnly = false, isSearch = false, onSearch, ...otherProps }, ref) => {
    return (React.createElement(S.Container, { className: className, isSearch: isSearch },
        React.createElement(S.Input, { ref: ref, ...otherProps, hasError: hasError, disabled: readOnly }),
        readOnly && React.createElement(S.Icon, { as: SvgLock, "aria-hidden": true }),
        isSearch && onSearch &&
            React.createElement(S.SearchBtn, { type: 'button', onClick: () => onSearch() },
                React.createElement(S.Search, { as: SvgSearch, "aria-hidden": true }))));
});
Textbox.displayName = 'Textbox';
export default Textbox;
